import { render } from "./UnsubscribeOptions.vue?vue&type=template&id=54ac41a6"
import script from "./UnsubscribeOptions.vue?vue&type=script&lang=js"
export * from "./UnsubscribeOptions.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__